import { makeStyles } from "@material-ui/core";
import React from "react";
import useButtonStyles from "../../../hooks/styles/useButtonStyles";
import { COLORS } from "../../../assets/theme";

type TButtonVariantColor =
  | "primary"
  | "secondary"
  | "disabled"
  | "danger"
  | "outline";

type Props = {
  variant: TButtonVariantColor;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const useStyles = makeStyles(() => ({
  root: {
    position: "fixed",
    bottom: 0,
    // left: "50%",
    width: "100%",
    borderTop: `3px solid ${COLORS.light_gray_1}`,
    opacity: 0,
    transition: "transform 0.3s, opacity 0.3s",
    zIndex: 999,
    backgroundColor: COLORS.white,
    padding: "16px 8px",
    transform: "translate(0, 0px)",
    maxWidth: 500,
  },
  show: {
    opacity: 1,
    transform: "translate(-0, 0)", // Move the button up by 50px
  },
  button: {
    width: "100%",
    fontSize: 13,
  },
}));

const FloatingBottomButton = ({
  variant = "secondary",
  disabled,
  children,
  ...rest
}: Props) => {
  const classes = useStyles();
  const btn_classes = useButtonStyles();
  return (
    <div className={`${classes.root} ${classes.show}`}>
      <button
        {...rest}
        className={`${btn_classes.button} ${
          disabled ? "disabled" : variant ? variant : ""
        } ${classes.button}`}
        disabled={disabled}
      >
        <span>{children}</span>
      </button>
    </div>
  );
};

export default FloatingBottomButton;
